import { Button } from 'ui-components/components/button';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import styles from './product-row-label.styles.module.less';

/**
 * Renders a product row that shows product name and sku
 * @param {object} props
 * @param {string} props.name - product name
 * @param {string} props.sku - product sku
 * @param {number} props.productId - product identifier
 * @param {(productId:number) => void} props.openProductDetails - open product details in modal
 * @returns {JSX.Element} A product row label for purchase order receive table
 */
export const ProductRowLabel = ({ name, sku, productId, openProductDetails }) => {
  return (
    <FlexColumn className={styles['flex-label']}>
      <Button className={styles['name-label']} onClick={() => openProductDetails(productId)} theme={THEME_CONSTANTS.link}>
        {name}
      </Button>
      <Text className={styles['sku-label']} textType={TextType.Caption} value={`SKU: ${sku}`} />
    </FlexColumn>
  );
};
